(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["globo.form.custom"] && !Shopify.designMode) return;
  try {
    document.addEventListener('globo.formbuilder.form.loaded', (event) => {
  const { form, formId } = event.detail || {};
  if (String(formId) !== '128149' || !form || form.dataset.glxSamplesReady) return;
  const select = form.querySelector('[name="select-6"]');
  const footer = form.querySelector('.gfb__footer');
  const submit = form.querySelector('button[type="submit"]');
  if (!select || !footer || !submit) return;
  form.dataset.glxSamplesReady = 'true';
  const proceed = submit.cloneNode(false);
  proceed.removeAttribute('id');
  proceed.removeAttribute('name');
  proceed.removeAttribute('disabled');
  proceed.type = 'button';
  const label = document.querySelector('[data-glx-sample-action-label]');
  proceed.textContent = label ? label.content.textContent.trim() : submit.textContent;
  proceed.addEventListener('click', () => {
    window.location.assign('/products/premium-sample-material');
  });
  footer.appendChild(proceed);
  const paidSamples = new Set(['Bernhardt Wood ($5)', 'Made Goods ($5)', 'Universal Furniture Wood ($5)']);
  const update = () => {
    const paid = paidSamples.has(select.value);
    submit.classList.toggle('gfb__hidden', paid);
    proceed.classList.toggle('gfb__hidden', !paid);
  };
  select.addEventListener('change', update);
  update();
});
  } catch(e) { console.error(e); }
})();

})();
